import apiInstance from "./apiInstance";

const getClassBranchReport = ({ params }) => {
  return apiInstance.post(`/jasperreports/lessonsofclass`, params);
};

const getClassroomStudentListReport = (params) => {
  return apiInstance.post(`/jasperreports/class-list`, params);
};

const getClassroomStudentPhotoListReport = (params) => {
  return apiInstance.post(`/jasperreports/classlistwithimage`, params);
};

const getPaymentReport = (params) => {
  return apiInstance.post(`/jasperreports/collection-receipt`, params);
};

const getPaymentReports = (params) => {
  return apiInstance.post(`/jasperreports/collection-receipts`, params);
};

const getUserInformationReport = (params) => {
  return apiInstance.post(`/jasperreports/user-information-report`, params);
};

const getOneUserInformationReport = (params) => {
  return apiInstance.post(`/jasperreports/user-information-report-for-one-student`, params);
};

const getSchoolAttendanceReport = (params) => {
  return apiInstance.post(`/jasperreports/school-attendance-between-dates`, params);
};

const getStudentProgressReport = (params) => {
  return apiInstance.post(`/jasperreports/student-progress`, params);
};

const getExamApplicationReport = (params) => {
  return apiInstance.post(`/jasperreports/exam-application-info-report`, params);
};

const getMultipleExamApplicationReport = (params) => {
  return apiInstance.post(`/jasperreports/exam-application-info-report/multiple`, params);
};

const getPaymentPlan = (params) => {
  return apiInstance.post(`/jasperreports/payment-plan`, params);
};

const getSessionRoomStudentsReport = (params) => {
  return apiInstance.post(`/jasperreports/session-room-list`, params);
};

const getExceptedPaymentsReport = (params) => {
  return apiInstance.post(`/jasperreports/expected-payments-between-dates`, params);
};

const getClassBasedProgressReportExam = (params) => {
  return apiInstance.post(`/jasperreports/class-based-progress-report-exam`, params);
};

const getClassBranchesNotes = (params) => {
  return apiInstance.post(`/jasperreports/class-branchs-notes`, params);
};

const getTermBehaviourReport = (params) => {
  return apiInstance.post(`/jasperreports/term-behaviour-report-of-students`, params);
};

const getLessonReports = (params) => {
  return apiInstance.post(`/jasperreports/class-lesson-report`, params);
};

const getTermScoreReport = (params) => {
  return apiInstance.post(`/jasperreports/term-report-of-students`, params);
};

const getClassroomStudentCards = (params) => {
  return apiInstance.post(`/jasperreports/class-student-cards`, params);
};

const getStudentCard = (params) => {
  return apiInstance.post(`/jasperreports/student-card`, params);
};

const getSchoolStudentCount = (params) => {
  return apiInstance.post(`/jasperreports/school-student-count`, params);
};

const registerCountComparisonReport = (params) => {
  return apiInstance.post(`/jasperreports/registerCountComparisonReport`, params);
};

const campusRegisterCountComparisonReport = (params) => {
  return apiInstance.post(`/jasperreports/campusRegisterCountComparisonReport`, params);
};

const getExamComparisonReport = (params) => {
  return apiInstance.post(`/jasperreports/school-exams-comparison`, params);
};

const getClassroomStudentExamReport = (params) => {
  return apiInstance.post(`/jasperreports/class-achievement-eval`, params);
};

const getStudentExamReport = (params) => {
  return apiInstance.post(`/jasperreports/student-achievement-eval`, params);
};

const getMailOrderReport = (contractId) => {
  return apiInstance.post(`/jasperreports/contract-mail-order-form/${contractId}`);
};

const getStudentCertificates = (params) => {
  return apiInstance.post(`/jasperreports/student-certificate`, params);
};

const getTeachersSurveyResults = (params) => {
  return apiInstance.post(`/jasperreports/survey-result-teacher`, params);
};

const getAccountingContractReport = (params) => {
  return apiInstance.post(`/jasperreports/accounting-contract-report`, params);
};

const getSittingPlanReport = (params) => {
  return apiInstance.post(`/jasperreports/sitting-plan-report`, params);
};

const getSittingStudentCardReport = ({ sittingPlanId, schoolId, params }) => {
  return apiInstance.post(
    `/jasperreports/sitting-plan-student-card/${sittingPlanId}/${schoolId}`,
    params
  );
};

const getPersonnelsSurveyResults = (params) => {
  return apiInstance.post(`/jasperreports/survey-result-manager`, params);
};

const getAttendanceReportByStudent = (params) => {
  return apiInstance.post(`/jasperreports/attendance-by-branch`, params);
};
const getSchoolServicesSurveyResults = (params) => {
  return apiInstance.post(`/jasperreports/survey-result-school-services`, params);
};
const getSurveyAverages = (params) => {
  return apiInstance.post(`/jasperreports/survey-averages`, params);
};
const getClassroomSyllabusReport = (params) => {
  return apiInstance.post(`/jasperreports/class-syllabus-report`, params);
};
const getTeacherSyllabusReport = (params) => {
  return apiInstance.post(`/jasperreports/teacher-syllabus-report`, params);
};
const getDelayedPaymentsSummaryReport = (params) => {
  return apiInstance.post(`/jasperreports/delayed-payments-summary-report`, params);
};
const getInventoryResult = (params) => {
  return apiInstance.post("/jasperreports/inventory-result", params);
};

const getSchoolStudentCounts = (params) => {
  return apiInstance.post("/jasperreports/school-student-count-list", params);
};

const getStudentVideoReport = (params) => {
  return apiInstance.post("/jasperreports/student-video-report", params);
};

const getStudentGenderCountReport = (params) => {
  return apiInstance.post("/jasperreports/student-gender-count", params);
};

const getJobInventoryResult = (params) => {
  return apiInstance.post("/jasperreports/student-job-inventory", params);
};

const branchEarningReport = (params) => {
  return apiInstance.post("/jasperreports/branchEarningReport", params);
};

const registerCountWithDetailReport = (params) => {
  return apiInstance.post("/jasperreports/registerCountWithDetailReport", params);
};

const campusRegisterCountWithDetailReport = (params) => {
  return apiInstance.post("/jasperreports/campusRegisterCountWithDetailReport", params);
};

const registerCountByClassReport = (params) => {
  return apiInstance.post("/jasperreports/registerCountByClassReport", params);
};

const campusRegisterCountByClassReport = (params) => {
  return apiInstance.post("/jasperreports/campusRegisterCountByClassReport", params);
};

const registerCountByLevelReport = (params) => {
  return apiInstance.post("/jasperreports/registerCountByLevelReport", params);
};

const campusRegisterCountByLevelReport = (params) => {
  return apiInstance.post("/jasperreports/campusRegisterCountByLevelReport", params);
};

const classroomNotesReport = (params) => {
  return apiInstance.post(`/jasperreports/classroomNotesReport`, params);
};

const classroomAttendanceReport = (params) => {
  return apiInstance.post(`/jasperreports/classroomAttendanceReport`, params);
};

const examStudentCountReport = (params) => {
  return apiInstance.post(`/examReport/examStudentCountSchoolBasedReport`, params);
};

const examStudentCountByClassReport = (params) => {
  return apiInstance.post(`/examReport/examStudentCountBranchBasedReport`, params);
};

const examStudentCountLevelReport = (params) => {
  return apiInstance.post(`/examReport/examStudentCountLevelBasedReport`, params);
};

const studentNotesReport = (params) => {
  return apiInstance.post("/jasperreports/studentNotesReport", params);
};

const personelInfosReport = (params) => {
  return apiInstance.post("/jasperreports/personelInfosReport", params);
};

const universityChoiceDataEntryReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceDataEntryReport `, params);
};

const universityChoiceSuccessByGradeReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceSuccessByGradeReport `, params);
};

const universityChoiceDataEntryByLevelReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceDataEntryByLevelReport `, params);
};

const universityChoiceSuccessCountReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceSuccessCountReport `, params);
};

const universityChoiceTop10Report = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceTop10Report `, params);
};

const universityChoiceCountReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceCountReport `, params);
};

const universityChoiceDepartmentReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceDepartmentReport `, params);
};

const universityChoiceAverageReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceAverageReport `, params);
};

const universityChoiceAverageWithLevelReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceAverageWithLevelReport `, params);
};

const universityChoiceAverageWithClassReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceAverageWithClassReport `, params);
};

const universityChoiceReport = (params) => {
  return apiInstance.post(`/jasperreports/universityChoiceReport `, params);
};

const teacherBasicHomeWorkReport = (params) => {
  return apiInstance.post(`/jasperreports/teacherBasicHomeWorkReport `, params);
};

const mentorTeacherHomeworkReport = (params) => {
  return apiInstance.post(`/jasperreports/mentorTeacherBasicHomeworkReport `, params);
};

const classroomBasicHomeWorkReport = (params) => {
  return apiInstance.post(`/jasperreports/classBasicHomeworkReport `, params);
};

const classroomDetailedBasicHomeWorkReport = (params) => {
  return apiInstance.post(`/jasperreports/classDetailBasicHomeworkReport `, params);
};

const caseOperationReport = (params) => {
  return apiInstance.post(`/jasperreports/caseOperationReport `, params);
};

const campusCaseOperationReport = (params) => {
  return apiInstance.post(`/jasperreports/campusBasedCaseOperationReport `, params);
};

const guidanceSummitAnswerCountsReport = (params) => {
  return apiInstance.post(`/jasperreports/guidanceSummitAnswerCountsReport`, params);
};

const guidanceSummitCommentsReport = (params) => {
  return apiInstance.post(`/jasperreports/guidanceSummitCommentsReport`, params);
};

const questionSolutionReport = (params) => {
  return apiInstance.post(`/jasperreports/questionSolutionReport`, params);
};

const studentNotesDateReport = (params) => {
  return apiInstance.post(`/jasperreports/studentNotesDateReport`, params);
};

const integrationReport = (params) => {
  return apiInstance.post(`/jasperreports/integrationReport`, params);
};

const scaleFormReport = (params) => {
  return apiInstance.post(`/jasperreports/scaleFormReport`, params);
};

const getSurveyAttendanceReport = (params) => {
  return apiInstance.post(`/jasperreports/surveyAttendanceReport`, params);
};

const scaleFormListReport = (params) => {
  return apiInstance.post(`/jasperreports/scaleFormListReport`, params);
};

const ribaReport = (params) => {
  return apiInstance.post(`/jasperreports/getRibaReport`, params);
};

const academicScaleReport = (scaleId) => {
  return apiInstance.post(`/jasperreports/academic-self-scale/${scaleId}`);
};

const studentAcademicScaleReport = ({ scaleId, studentRoleId }) => {
  return apiInstance.post(`/jasperreports/student-academic-self-scale/${scaleId}/${studentRoleId}`);
};

const pdrFormReport = (params) => {
  return apiInstance.post(`/jasperreports/pdrFormReport`, params);
};

const basicHomeworkStatusReport = ({ classId, params }) => {
  return apiInstance.post(`/jasperreports/basicHomeworkStatusReport/${classId}`, params);
};

const basicHomeworkControlReport = ({ classId, basicHomeworkIds }) => {
  return apiInstance.post(`/jasperreports/basicHomeworkControlReport/${classId}`, basicHomeworkIds);
};

const etudeReport = (params) => {
  return apiInstance.post(`/jasperreports/etudeReport`, params);
};

const etudeAttendanceReport = (params) => {
  return apiInstance.post(`/jasperreports/etudeAttendanceReport`, params);
};

const counselingReport = (params) => {
  return apiInstance.post(`/jasperreports/get-interview-report-interval`, params);
};
const counselingTeacherReport = (params) => {
  return apiInstance.post(`/jasperreports/get-teacher-interview-report`, params);
};

const examDegreesStudent = (params) => {
  return apiInstance.post(`/jasperreports/examDegreesStudent`, params);
};

const personalityReport = (inventoryId) => {
  return apiInstance.get(`/jasperreports/personalityInventoryReportByInventoryId/${inventoryId}`);
};

const studentInfoReport = (params) => {
  return apiInstance.post(`/jasperreports/studentInfosJasperReports`, params);
};

const corporationStudentInfoWithCityReport = (params) => {
  return apiInstance.post(`/jasperreports/corporationStudentInfoWithCityReport`, params);
};

const conservatorInfoReport = (params) => {
  return apiInstance.post(`/jasperreports/corporationParentInfoReport`, params);
};
const cityParentInfoReport = (params) => {
  return apiInstance.post(`/jasperreports/cityParentInfoReport`, params);
};
const studentExams = (classId) => {
  return apiInstance.get(`/examAssesment/getExamBasicInfo/${classId}`);
};

const getUserMessageInboxReport = (userId) => {
  return apiInstance.get(`/jasperreports/getUserMessageInboxReport/${userId}`);
};

const selfIdWeekInfoStudentReport = (params) => {
  return apiInstance.post(`/jasperreports/selfIdWeekInfoStudentReport`, params);
};

const pdrPersonalityInventoryConservatorNoResult = (params) => {
  return apiInstance.post(`/jasperreports/pdrPersonalityInventoryConservatorNoResult`, params);
};

const pdrPersonalityInventoryStudentNoResult = (params) => {
  return apiInstance.post(`/jasperreports/pdrPersonalityInventoryStudentNoResult`, params);
};
const selfIdWeekInfoClassReport = (params) => {
  return apiInstance.post(`/jasperreports/selfIdWeekInfoClassReport`, params);
};

const questionPoolCountInfoReportV1 = () => {
  return apiInstance.get(`/jasperreports/questionPoolCountInfoReportV1`);
};

const questionPoolCountInfoReportV2 = () => {
  return apiInstance.get(`/jasperreports/questionPoolCountInfoReportV2`);
};
const learnStyleDeterminationSchoolReport = (params) => {
  return apiInstance.post(`/jasperreports/learnStyleDeterminationSchoolReport`, params);
};

const learnStyleDeterminationStudentReport = () => {
  return apiInstance.get(`/jasperreports/learnStyleDeterminationStudentReport`);
};

const summaryMonthlyStudentsRegistrationReport = (params) => {
  return apiInstance.post(`/jasperreports/summaryMonthlyStudentsRegistrationReport`, params);
};

const studentRegistrationDeletionReportUserRoleId = (userRoleId) => {
  return apiInstance.get(`/jasperreports/studentRegistrationDeletionReport/${userRoleId}`);
};

const conservatorReport = (params) => {
  return apiInstance.post(`/jasperreports/conservatorInfoReport`, params);
};
const pdrPersonalityInventoryStudentSchool = (params) => {
  return apiInstance.post(`/jasperreports/pdrPersonalityInventoryStudentSchool`, params);
};
const pdrPersonalityInventoryConservatorSchool = (params) => {
  return apiInstance.post(`/jasperreports/pdrPersonalityInventoryConservatorSchool`, params);
};

export {
  studentExams,
  ribaReport,
  conservatorInfoReport,
  cityParentInfoReport,
  corporationStudentInfoWithCityReport,
  personalityReport,
  studentAcademicScaleReport,
  examDegreesStudent,
  academicScaleReport,
  counselingReport,
  studentInfoReport,
  etudeReport,
  basicHomeworkStatusReport,
  pdrFormReport,
  scaleFormListReport,
  scaleFormReport,
  getSurveyAttendanceReport,
  integrationReport,
  studentNotesDateReport,
  questionSolutionReport,
  guidanceSummitCommentsReport,
  guidanceSummitAnswerCountsReport,
  caseOperationReport,
  campusCaseOperationReport,
  registerCountComparisonReport,
  campusRegisterCountComparisonReport,
  personelInfosReport,
  teacherBasicHomeWorkReport,
  mentorTeacherHomeworkReport,
  classroomBasicHomeWorkReport,
  classroomDetailedBasicHomeWorkReport,
  universityChoiceReport,
  universityChoiceAverageWithClassReport,
  universityChoiceAverageWithLevelReport,
  universityChoiceAverageReport,
  universityChoiceDepartmentReport,
  universityChoiceCountReport,
  studentNotesReport,
  examStudentCountLevelReport,
  universityChoiceTop10Report,
  universityChoiceSuccessCountReport,
  universityChoiceDataEntryByLevelReport,
  universityChoiceSuccessByGradeReport,
  universityChoiceDataEntryReport,
  examStudentCountByClassReport,
  examStudentCountReport,
  classroomAttendanceReport,
  classroomNotesReport,
  registerCountWithDetailReport,
  registerCountByClassReport,
  registerCountByLevelReport,
  branchEarningReport,
  getOneUserInformationReport,
  getClassBranchReport,
  getClassroomStudentListReport,
  getClassroomStudentPhotoListReport,
  getPaymentReport,
  getPaymentReports,
  getUserInformationReport,
  getSchoolAttendanceReport,
  getStudentProgressReport,
  getExamApplicationReport,
  getPaymentPlan,
  getSessionRoomStudentsReport,
  getExceptedPaymentsReport,
  getClassBasedProgressReportExam,
  getClassBranchesNotes,
  getMultipleExamApplicationReport,
  getTermBehaviourReport,
  getLessonReports,
  getTermScoreReport,
  getClassroomStudentCards,
  getStudentCard,
  getSchoolStudentCount,
  getExamComparisonReport,
  getClassroomStudentExamReport,
  getStudentExamReport,
  getMailOrderReport,
  getStudentCertificates,
  getTeachersSurveyResults,
  getAccountingContractReport,
  getSittingPlanReport,
  getPersonnelsSurveyResults,
  getSchoolServicesSurveyResults,
  getAttendanceReportByStudent,
  getSurveyAverages,
  getClassroomSyllabusReport,
  getTeacherSyllabusReport,
  getDelayedPaymentsSummaryReport,
  getInventoryResult,
  getSchoolStudentCounts,
  getStudentVideoReport,
  getStudentGenderCountReport,
  getJobInventoryResult,
  getSittingStudentCardReport,
  campusRegisterCountByLevelReport,
  campusRegisterCountByClassReport,
  campusRegisterCountWithDetailReport,
  getUserMessageInboxReport,
  selfIdWeekInfoStudentReport,
  pdrPersonalityInventoryConservatorNoResult,
  pdrPersonalityInventoryStudentNoResult,
  selfIdWeekInfoClassReport,
  questionPoolCountInfoReportV1,
  questionPoolCountInfoReportV2,
  learnStyleDeterminationStudentReport,
  learnStyleDeterminationSchoolReport,
  summaryMonthlyStudentsRegistrationReport,
  basicHomeworkControlReport,
  studentRegistrationDeletionReportUserRoleId,
  conservatorReport,
  pdrPersonalityInventoryStudentSchool,
  pdrPersonalityInventoryConservatorSchool,
  etudeAttendanceReport,
  counselingTeacherReport
};
